import {createSetTitleCallbackApp, sendCallback} from "../../../assets/js/app-callbacks";

class VeranstaltungsKalender extends HTMLElement {

  connectedCallback() {
    this.setDataAttributes();
    this.setElements();
    this.bindEvents();
    this.initFilter();
    this.initVeranstaltungen();
    if (this.sindAppCallbacksAktiv) {
      this.appCallbackSetTitle(this, this.dataset.buchhandlung);
    }
  }

  setDataAttributes() {
    this.selectedSapId = this.dataset.selectedSapid;
    this.selectedStadt = this.dataset.selectedStadt;
    this.selectedMonat = this.dataset.selectedMonat;
    this.loadUrl = this.dataset.loadUrl;
    this.nextPage = 0;
  }

  setElements() {
    this.stadtSelectElement = document.querySelector('.stadt-select');
    this.monatSelectElement = document.querySelector('.monat-select');
    this.nachladenButton = document.querySelector('.button-weitere');
    this.veranstaltungContainer = document.querySelector('.veranstaltung-container');
    this.veranstaltungLeerContainer = document.querySelector('.veranstaltung-container-leer');
    this.anzahlVeranstaltungenElement = document.querySelector('.veranstaltung-anzahl');
  }

  bindEvents() {
    if (this.hasStadtFilter()) {
      this.stadtSelectElement.addEventListener('change', () => {
        this.selectedStadt = this.stadtSelectElement.value;
        this.initVeranstaltungen();
      });
    }

    this.monatSelectElement.addEventListener('change', () => {
      this.selectedMonat = this.monatSelectElement.value;
      this.initVeranstaltungen();
    });
    this.nachladenButton.addEventListener('click', () => {
      this.loadVeranstaltungen();
    })
  }

  hasStadtFilter() {
    return this.selectedSapId === "";
  }

  initFilter() {
    if (this.hasStadtFilter()) {
      this.stadtSelectElement.value = this.selectedStadt;
    }
    this.monatSelectElement.value = this.selectedMonat;
  }

  async initVeranstaltungen() {
    this.changeVisibility(this.nachladenButton, false);
    this.changePageUrl();
    this.veranstaltungContainer.innerHTML = "";
    this.nextPage = 0;
    this.loadVeranstaltungen();
  }

  changeVisibility(element, visible) {
    if (visible) {
      element.removeAttribute('hidden');
    } else {
      element.setAttribute('hidden', true);
    }

  }

  loadVeranstaltungen() {
    fetch(this.getVeranstaltungsseiteUrl())
      .then(response => {
        if (!response.ok) {
          throw response;
        }
        return response.text();
      })
      .then(text => this.onVeranstaltungsseiteReceived(text))
      .catch(error => console.error(error));
  }

  getVeranstaltungsseiteUrl() {
    return `${this.loadUrl}${this.getParamString(this.nextPage, new URLSearchParams())}`;
  }

  onVeranstaltungsseiteReceived(text) {
    const responseHtml = document.createElement("veranstaltung-seite");
    responseHtml.innerHTML = text;

    const pageElement = responseHtml.firstElementChild;
    const nextPage = pageElement.dataset.nextPage;
    const anzahlVeranstaltungen = pageElement.dataset.totalElements;
    const veranstaltungText = pageElement.dataset.veranstaltungText;

    this.changeVisibility(this.veranstaltungLeerContainer, anzahlVeranstaltungen === "0");
    this.changeVisibility(this.veranstaltungContainer, anzahlVeranstaltungen !== "0");

    this.nextPage = nextPage ? nextPage : null;
    this.changeVisibility(this.nachladenButton, this.nextPage);
    this.anzahlVeranstaltungenElement.innerHTML = `${anzahlVeranstaltungen} ${veranstaltungText}`;

    Array.from(pageElement.children).forEach(veranstaltung => this.veranstaltungContainer.appendChild(veranstaltung));
  }

  changePageUrl() {
    let existingParams = new URLSearchParams(location.search);

    window.history.pushState({}, null, this.getParamString(null, existingParams));
  }

  get sindAppCallbacksAktiv() {
    return this.dataset.appCallbacksActive === 'true';
  }

  appCallbackSetTitle(parent, buchhandlung) {
    let title = 'Veranstaltungskalender';
    if (buchhandlung) {
      title = title.concat(' für ' + buchhandlung);
    }
    sendCallback(createSetTitleCallbackApp('setTitle', title), parent);
  }

  getParamString(page, existingParams) {
    let params = existingParams;

    params.set("monat", this.selectedMonat);

    if (this.hasStadtFilter()) {
      params.set("stadt", this.selectedStadt);
      params.delete("sapId");
    } else {
      params.set("sapId", this.selectedSapId);
      params.delete("stadt");
    }

    if (page !== null) {
      params.set("page", page);
    } else {
      params.delete("page");
    }
    return params.size > 0 ? `?${params.toString()}`: '';
  }
}

if (!customElements.get("veranstaltungs-kalender")) {
  customElements.define("veranstaltungs-kalender", VeranstaltungsKalender);
}
